import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources"
import CrmAccount from "../../model2/crm/account/model"
import exportToCsv from "../../gd-modules/export-to-csv/export-to-csv"

export default class CRMAccountsResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, CrmAccount, options)
    }

    exportToCSV(arrayOfFields: any[], arrayOfIds: string[] = [], fileName: string = 'crm-accounts'): void {
        const list: any[] = []
        // csv header
        const header: string[] = ['Id'] // id always present and is first
        _.map(arrayOfFields, field=>{
            header.push(field.label)
        })
        list.push(header)

        // iterate through models to get export info for each required
        _(this.models)
            .filter(model=>_.isEmpty(arrayOfIds) || arrayOfIds.includes(model.id)) // filter according to arrayOfIds if any
            .map(model=>{ // add row for each resource item
                const values: any[] = [model.id] // id always present and is first

                _.map(arrayOfFields, field=>{
                    values.push(field.normalizeToCSVValue(model))
                })

                list.push(values)
            })
            .value()

        exportToCsv(list, '{0}.csv'.f(fileName))
    }

    importFromCSV(data: any, fieldCollection: any): void {
        super.importFromCSV(data, fieldCollection);
    }
}